import 'core-js';
import "regenerator-runtime/runtime";
import React from 'react';
import ReactDOM from 'react-dom';
import 'whatwg-fetch';

import ArtContestAppRouter from './routers/ArtContestAppRouter';
import { LocalizationContextProvider } from './contexts/localization-context'; 
import { ArtsContextProvider } from './contexts/arts-context';

require('babel-polyfill');

ReactDOM.render(
    <ArtsContextProvider>
        <LocalizationContextProvider>
            <ArtContestAppRouter/>
        </LocalizationContextProvider>
    </ArtsContextProvider>
    , 
    document.getElementById('ArtContestApp')
);